import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { MenuProduto } from '../models/menuproduto';

@Injectable({
  providedIn: 'root'
})
export class MenuProdutoService {

  constructor(private http: HttpClient) {
  }

  consultarMenuProdutos() {
    return this.http.get<any>(globals.apiUrl + '/api/MenuProduto/BuscarMenuProdutos');
  }

  consultarMenuPorId(idmenu: any) {
    return this.http.get<any>(globals.apiUrl + '/api/MenuProduto/BuscarMenuPorId',
      { params: new HttpParams().set('idmenu', idmenu) });
  }

  consultarListaMenu() {
    return this.http.get<any>(globals.apiUrl + '/api/MenuProduto/BuscarListaMenu');
  }

  salvar(menu: MenuProduto) {
    return this.http.post(globals.apiUrl + '/api/MenuProduto/Salvar', menu);
  }

  excluir(id: any) {
    return this.http.get<any>(globals.apiUrl + '/api/MenuProduto/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
